/* ==========================================================================
   NIG 使用例ギャラリー — 絞り込み・URL 同期・もっと見る
   対象テーマ: Shopify Dawn 15.5.0

   全カードを最初から DOM に出しておき、条件に合わないものを hidden にする
   （サーバー往復なしで切り替わるほうが、回線の細い環境でも軽い）。

   URL パラメータに対応する。メルマガ・LP・商品ページから
   「その商品の使用例だけ」に直リンクできるようにするため。
     /pages/voices?product=pockepa
     /pages/voices?scene=子育て,旅行     （カンマ区切り・複数可）

   絞り込みの条件:
     商品   … 単一選択（AND）
     シーン … 複数選択。選んだシーンの「いずれか」に当てはまれば表示（OR）。
              AND にすると 2 つ選んだだけで 0 件になりやすいため。

   動画の再生制御は voices-video.js の担当。絞り込みで表示が変わったら
   voices:filtered イベントを投げて、あちらに再評価させる。
   ========================================================================== */
(function () {
  'use strict';

  var root = document.querySelector('[data-voices]');
  if (!root) return;

  var grid = root.querySelector('[data-voices-grid]');
  var cards = Array.prototype.slice.call(root.querySelectorAll('[data-voices-card]'));
  var productTabs = Array.prototype.slice.call(root.querySelectorAll('[data-product-tab]'));
  var sceneChips = Array.prototype.slice.call(root.querySelectorAll('[data-scene-chip]'));
  var countNode = root.querySelector('[data-voices-count]');
  var emptyNode = root.querySelector('[data-voices-empty]');
  var moreButton = root.querySelector('[data-voices-more]');
  var resetButton = root.querySelector('[data-voices-reset]');
  if (!grid || cards.length === 0) return;

  var pageSize = parseInt(root.getAttribute('data-page-size'), 10) || 40;
  var limit = pageSize;
  var selectedProduct = '';
  var selectedScenes = [];

  /* ------------------------------------------------------------------ *
   * 判定
   * ------------------------------------------------------------------ */
  function cardScenes(card) {
    return (card.getAttribute('data-scenes') || '')
      .split(',')
      .map(function (s) { return s.trim(); })
      .filter(Boolean);
  }

  function matches(card) {
    if (selectedProduct && card.getAttribute('data-product') !== selectedProduct) return false;
    if (selectedScenes.length === 0) return true;
    var scenes = cardScenes(card);
    return selectedScenes.some(function (wanted) {
      return scenes.indexOf(wanted) !== -1;
    });
  }

  function isFiltering() {
    return Boolean(selectedProduct) || selectedScenes.length > 0;
  }

  /* ------------------------------------------------------------------ *
   * 表示
   * ------------------------------------------------------------------ */
  function apply() {
    var shown = 0;
    var matched = 0;

    cards.forEach(function (card) {
      if (!matches(card)) {
        card.hidden = true;
        return;
      }
      matched++;
      if (shown < limit) {
        card.hidden = false;
        shown++;
      } else {
        card.hidden = true;
      }
    });

    if (countNode) {
      if (matched === 0) {
        countNode.textContent = '';
      } else if (matched <= shown) {
        countNode.textContent = matched + '件を表示しています';
      } else {
        countNode.textContent = matched + '件中 ' + shown + '件を表示しています';
      }
    }
    if (emptyNode) emptyNode.hidden = matched !== 0;
    if (moreButton) moreButton.hidden = matched <= shown;
    if (resetButton) resetButton.hidden = !isFiltering();

    // 動画の再生対象が変わるので、voices-video.js に再評価させる
    document.dispatchEvent(new CustomEvent('voices:filtered'));
  }

  function syncButtons() {
    productTabs.forEach(function (tab) {
      var value = tab.getAttribute('data-product-tab') || '';
      tab.setAttribute('aria-pressed', value === selectedProduct ? 'true' : 'false');
    });
    sceneChips.forEach(function (chip) {
      var value = chip.getAttribute('data-scene-chip') || '';
      chip.setAttribute('aria-pressed', selectedScenes.indexOf(value) !== -1 ? 'true' : 'false');
    });
  }

  /* ------------------------------------------------------------------ *
   * URL との同期
   * ------------------------------------------------------------------ */
  function readUrl() {
    var params = new URLSearchParams(window.location.search);
    var product = (params.get('product') || '').trim();
    if (product) {
      var known = productTabs.some(function (tab) {
        return tab.getAttribute('data-product-tab') === product;
      });
      if (known) selectedProduct = product;
    }
    var scene = params.get('scene') || '';
    if (scene) {
      var wanted = scene.split(',').map(function (s) { return s.trim(); }).filter(Boolean);
      var available = sceneChips.map(function (chip) { return chip.getAttribute('data-scene-chip'); });
      selectedScenes = wanted.filter(function (s) { return available.indexOf(s) !== -1; });
    }
  }

  function writeUrl() {
    if (!window.history || !window.history.replaceState) return;
    var params = new URLSearchParams(window.location.search);
    if (selectedProduct) {
      params.set('product', selectedProduct);
    } else {
      params.delete('product');
    }
    if (selectedScenes.length > 0) {
      params.set('scene', selectedScenes.join(','));
    } else {
      params.delete('scene');
    }
    var query = params.toString();
    window.history.replaceState(null, '', window.location.pathname + (query ? '?' + query : ''));
  }

  /* GA4。gtag が無いページでも落ちないようにする */
  function sendFilterEvent() {
    if (typeof window.gtag !== 'function') return;
    window.gtag('event', 'filter_voices', {
      voice_product: selectedProduct || '(all)',
      voice_scenes: selectedScenes.length ? selectedScenes.join(',') : '(none)',
      voice_result_count: cards.filter(matches).length
    });
  }

  function update() {
    limit = pageSize; // 条件を変えたら先頭から見せ直す
    syncButtons();
    apply();
    writeUrl();
    sendFilterEvent();
  }

  /* ------------------------------------------------------------------ *
   * 操作
   * ------------------------------------------------------------------ */
  productTabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      var value = tab.getAttribute('data-product-tab') || '';
      selectedProduct = value === selectedProduct ? '' : value;
      update();
    });
  });

  sceneChips.forEach(function (chip) {
    chip.addEventListener('click', function () {
      var value = chip.getAttribute('data-scene-chip') || '';
      var index = selectedScenes.indexOf(value);
      if (index === -1) {
        selectedScenes.push(value);
      } else {
        selectedScenes.splice(index, 1);
      }
      update();
    });
  });

  if (moreButton) {
    moreButton.addEventListener('click', function () {
      limit += pageSize;
      apply();
      // 追加分の先頭にフォーカスを移し、キーボードでも続きから追えるようにする
      var next = cards.filter(function (card) { return !card.hidden; }).pop();
      if (next) {
        var button = next.querySelector('button');
        if (button) button.focus({ preventScroll: true });
      }
    });
  }

  if (resetButton) {
    resetButton.addEventListener('click', function () {
      selectedProduct = '';
      selectedScenes = [];
      update();
    });
  }

  readUrl();
  syncButtons();
  apply();
})();
